import React from 'react';
import { Card, List, Button, Typography, Spin } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { useTheme } from '@/components/common/ThemeProvider';
import {FileMetaDataDto} from '@/shared/api/model';
import {useGetMetaByCategory} from "@/hooks/posts/file";

const { Title } = Typography;

const ImportantAttachments: React.FC = () => {
    const { dark } = useTheme();
    const [{ data: attachments, isLoading, error }] = useGetMetaByCategory('DOWNLOAD');
    const attachmentList: FileMetaDataDto[] = Array.isArray(attachments) ? attachments : (attachments as any)?.data || [];

    if (isLoading) {
        return (
            <Card className={dark ? 'bg-gray-800' : ''}>
                <Spin />
            </Card>
        );
    }

    if (error) {
        return (
            <Card className={dark ? 'bg-gray-800' : ''}>
                <Title level={4} className={dark ? 'text-white' : ''}>Error</Title>
                <p className={dark ? 'text-red-400' : 'text-red-600'}>
                    Failed to load attachments: {error.message}
                </p>
            </Card>
        );
    }

    const handleDownload = (file: FileMetaDataDto) => {
        // Implement download logic here
        console.log('Downloading file:', file.fileName);

        const headers = new Headers();
        const downloadUrl = `/api/files/${file.relativePath}`;
        fetch(downloadUrl, { headers })
            .then((response) => {
                if (response.ok) {
                    window.open(downloadUrl, "_blank");
                } else {
                    console.error("Failed to download file");
                }
            })
            .catch((error) => {
                console.error("Error occurred while downloading file:", error);
            });
    };

    return (
        <Card className={dark ? 'bg-gray-800' : ''}>
            <Title level={4} className={dark ? 'text-white' : ''}>Important Attachments</Title>
            <List
                itemLayout="horizontal"
                dataSource={attachmentList}
                renderItem={(item: FileMetaDataDto) => (
                    <List.Item>
                        <Button
                            icon={<FileOutlined />}
                            type="link"
                            className={dark ? 'text-blue-400' : 'text-blue-600'}
                            onClick={() => handleDownload(item)}
                        >
                            {item.fileName}
                        </Button>
                    </List.Item>
                )}
            />
        </Card>
    );
};

export default ImportantAttachments;